import BuyerAssuranceGradient from '../src/BuyerAssuranceGradient';
export default BuyerAssuranceGradient;
